import { CognitoUserPool } from 'amazon-cognito-identity-js';

// localstorage username == demo


const REGION = process.env.REACT_APP_AWS_REGION;
const USER_POOL_ID = process.env.REACT_APP_AWS_ADMIN_POOL_ID;
const CLIENT_ID = process.env.REACT_APP_AWS_CLIENT_ID;
const poolData = { UserPoolId: USER_POOL_ID, ClientId: CLIENT_ID };


const REGIONTest = "ap-south-1";
const USER_POOL_IDTest = "ap-south-1_FZAVnPHeE";
const CLIENT_IDTest = "1m1r3q6rqgbggj2fki7d1iigkh";
const poolDataTest = { UserPoolId: USER_POOL_IDTest, ClientId: CLIENT_IDTest };





export const userPool = new CognitoUserPool(poolData);
export const userPoolTest = new CognitoUserPool(poolDataTest);
export const USERPOOL_ID = 'cognito-idp.' + REGION + '.amazonaws.com/' + USER_POOL_ID;
export const USERPOOL_IDTest = 'cognito-idp.' + REGIONTest + '.amazonaws.com/' + USER_POOL_IDTest;